const base64Pattern =
  /^(?:[A-Za-z0-9+/]{4})*?(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

/**
 * Determines whether a string is a base64 encoded string.
 */
export const isBase64 = (str: string): boolean => base64Pattern.test(str);

/**
 * Determines whether a string is likely base64 encoded,
 * rejecting strings shorter than minLen to avoid false positives.
 */
export const maybeBase64 = (str: string, minLen: number = 256): boolean =>
  str.length > minLen && isBase64(str);
